// <핫이슈 박스 컴포넌트>

// 2021.11.01 기획서 기준  광고까지 총 5개 박스

// 5. 기타
// CCI 관리자에서 Type 1~4 및 구글 AD 및 인하우스 배너 수동입력 가능
// 수동 입력되는 배열순서는 시간으로 입력 또는 순서번호로 입력, 단 구글 광고는 순서로만 입력
// Google AD 사이즈 : 336 * 280
// 인하우스 배너 : 가로 고정, 세로는 최소/최대 높이 제한
// 모든 링크에 통계 파라미터 삽입 div=hotissue

import React, { useState, useRef, useEffect } from 'react';
import Image from 'next/image';
import VideoPlayer from '../../../pc/video/video-player';
import Link from 'next/link';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

export default function Box(props) {
  const [width, setWidth] = useState(384);
  const [height, setHeight] = useState(0);
  // 인하우스 배너

  // "type": 7,
  // "title": "Type6_인하우스배너_수동순서_꼬꼬무",
  // "img_url": [
  //     "https://img2.sbs.co.kr/img/sbs_cms/WE/2021/11/24/Q9Q1637714343672.jpg"
  // ],
  // "link_url": "https://programs.sbs.co.kr/culture/thetail/event/70428",
  // "content_date": "20211201165208",
  // "sort": 7

  const title = props.title; // 타이틀
  const imgUrlList = props.img_url; // 이미지 주소 urlList 맥시멈 갯수 5개 혹시 몰라서 구현시에는 동적으로 구현
  const linkUrl = props.link_url; // 링크 url
  // TODO childmild
  // 이미지 유형 체크
  try {
    const test = imgUrlList[0].substr(0, 4);
    if (test !== 'http') {
      return (
        <>
        </>
      );
    }
  } catch (error) {
    console.error(error);
    return (
      <>
      </>
    );
  }

  const handleImageLoad = (e) => {
    const nHeight = e.naturalHeight;
    const nWidth = e.naturalWidth;
    const scale = e.naturalWidth / 384;
    const scaleHeight = nHeight / scale;
    setHeight(scaleHeight);
    if (props.forceUpdate) {
      props.forceUpdate();
    }
  };

  return (
    <>
      <div className='hotmodule_box_w_type7'>
        <Link href={getClickLinkParams(linkUrl, 'div=hotissue')}>
          <a target={"_blank"} rel={"noopener noreferrer"} className='hmb_link'>

            {imgUrlList[0].endsWith('.gif')
              ? <img
                src={imgUrlList[0]}
                alt={title}
              />
              : <Image
                onLoadingComplete={(e) => handleImageLoad(e)}
                layout='responsive'
                objectFit='fill'
                width={width}
                height={height}
                src={imgUrlList[0]}
                alt={title}
              />}
          </a>
        </Link>
      </div>
    </>
  );
}// Finish default function Box()
